const TimeFlyingSVG = (): JSX.Element => (
  <svg
    aria-hidden="true"
    width="128px"
    height="122px"
    viewBox="0 0 128 122"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-549.000000, -1311.000000)" id="Group-3">
        <g transform="translate(549.000000, 1311.000000)">
          <path
            d="M118,40.5003432 C118,24.1853125 104.73385,11 88.5,11 C72.2334318,11 59,24.2408268 59,40.5003432 C59,48.526582 62.2235455,55.8131668 67.4420955,61.1374424 C67.5775273,61.3066671 67.7019636,61.4292276 67.8631409,61.5587609 C79.5389727,73.0035532 98.0330591,72.6870949 109.359718,61.3605723 C114.796836,55.9131998 118,48.4619495 118,40.5003432 Z M106.650814,54.8584284 C105.603295,53.8114344 103.905705,53.8114344 102.857918,54.8584284 C101.810668,55.9056906 101.810668,57.6038376 102.857918,58.651368 L103.556532,59.350258 C100.083845,62.1297267 95.8299455,63.9710845 91.18155,64.4873405 L91.18155,63.4878152 C91.18155,62.006898 89.9806318,60.8059658 88.4997318,60.8059658 C87.0188318,60.8059658 85.8179136,62.0066298 85.8179136,63.4878152 L85.8179136,64.4873405 C81.1695182,63.9710845 76.9158864,62.1297267 73.4429318,59.350258 L74.1415455,58.651368 C75.1887955,57.6041058 75.1887955,55.9059588 74.1415455,54.8584284 C73.0940273,53.8114344 71.3964364,53.8114344 70.34865,54.8584284 L69.6500364,55.5573184 C66.8703318,52.0845916 65.0292636,47.8306421 64.5130136,43.1821926 L65.5127955,43.1821926 C66.9936955,43.1821926 68.1946136,41.9815286 68.1946136,40.5003432 C68.1946136,39.0191578 66.9936955,37.8184938 65.5127955,37.8184938 L64.5130136,37.8184938 C65.0292636,33.1700443 66.8706,28.916363 69.6500364,25.4436362 L70.34865,26.142258 C71.3964364,27.1895202 73.0937591,27.189252 74.1415455,26.142258 C75.1887955,25.0949958 75.1887955,23.3968488 74.1415455,22.3493184 L73.4429318,21.6504285 C76.9156182,18.8706916 81.1695182,17.029602 85.8179136,16.513346 L85.8179136,17.5131394 C85.8179136,18.9943248 87.0188318,20.1949888 88.4997318,20.1949888 C89.9806318,20.1949888 91.18155,18.9943248 91.18155,17.5131394 L91.18155,16.513346 C95.8299455,17.029602 100.083577,18.8709598 103.556532,21.6504285 L102.857918,22.3493184 C101.810668,23.3965806 101.810668,25.0947276 102.857918,26.142258 C103.905705,27.1895202 105.603027,27.189252 106.650814,26.142258 L107.349427,25.4436362 C110.128864,28.916363 111.9702,33.1703125 112.48645,37.8184938 L111.486668,37.8184938 C110.005768,37.8184938 108.80485,39.0191578 108.80485,40.5003432 C108.80485,41.9815286 110.005768,43.1821926 111.486668,43.1821926 L112.48645,43.1821926 C111.9702,47.8306421 110.129132,52.0845916 107.349427,55.5573184 L106.650814,54.8584284 Z"
            id="Shape"
            fill="#000000"
            fillRule="nonzero"
          ></path>
          <path
            d="M95.0600819,38.1057799 L89.0375394,41.066668 L82.647231,34.7838471 C81.5844935,33.7387176 79.861356,33.7387176 78.7972573,34.7838471 C77.7342476,35.8289766 77.7342476,37.5236655 78.7972573,38.568795 L86.5747867,46.2157708 C87.4023282,47.0293928 88.6675957,47.2333336 89.7172668,46.717326 L97.4947962,42.8938381 C98.839279,42.2327702 99.3842586,40.6250639 98.7121533,39.3029283 C98.0400481,37.980525 96.4045647,37.4444444 95.0600819,38.1057799 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
          ></path>
          <path
            d="M116.51472,68.1104817 C123.612973,60.8788804 128,50.9663969 128,40.0450452 C128,17.9642073 110.075228,0 88.0428611,0 C77.1457502,0 67.2552928,4.39641203 60.0395663,11.5100139 C59.7556042,11.7313295 62.2790307,9.2466679 8.93172187,62.6979933 C7.89150436,63.7404994 7.89150436,65.4309342 8.93172187,66.4737072 C9.97220577,67.5162132 11.6586634,67.5159462 12.6988809,66.4737072 L49.4583832,29.6333335 C46.1339492,41.9949719 48.8094792,55.8030375 57.8560419,66.2542603 L6.78016314,117.442507 C5.73994562,118.485013 5.73994562,120.175448 6.78016314,121.218221 C7.82064703,122.260727 9.50710467,122.26046 10.5475886,121.218221 L61.6074844,70.0457252 C71.9446626,79.2056288 85.823908,82.1198403 98.4314509,78.7149436 L63.5560609,113.666526 C62.5158434,114.709032 62.5158434,116.399467 63.5560609,117.44224 C64.5965448,118.484746 66.2827361,118.484479 67.3234863,117.44224 C98.3480736,86.3413889 116.339974,68.3358018 116.51472,68.1104817 Z M53.4133408,40.0450452 C53.4133408,20.908319 68.9478772,5.33933936 88.0428611,5.33933936 C107.137845,5.33933936 122.672381,20.908319 122.672381,40.0450452 C122.672381,59.1820384 107.137845,74.750751 88.0428611,74.750751 C68.9478772,74.750751 53.4133408,59.1817714 53.4133408,40.0450452 Z"
            id="Shape"
            fill="#000000"
            fillRule="nonzero"
          ></path>
          <path
            d="M4.55774787,93.2181922 L41.218094,56.5577587 C42.2606353,55.5152149 42.2606353,53.8247187 41.218094,52.7819079 C40.1755526,51.739364 38.4850605,51.739364 37.4422521,52.7819079 L0.781906018,89.4423414 C-0.260635339,90.4848852 -0.260635339,92.1753814 0.781906018,93.2181922 C1.82498133,94.2607361 3.51520651,94.2604691 4.55774787,93.2181922 Z"
            id="Path"
            fill="#000000"
          ></path>
          <path
            d="M71.2147884,83.7848227 C70.1678397,82.7383924 68.4711716,82.7383924 67.4239548,83.7848227 L42.7850105,108.42418 C41.7383298,109.470878 41.7383298,111.168111 42.7850105,112.215077 C43.8319593,113.261775 45.5288954,113.261507 46.5758441,112.215077 L71.2147884,87.5757198 C72.2617372,86.5287535 72.2617372,84.8315209 71.2147884,83.7848227 Z"
            id="Path"
            fill="#09ADB9"
          ></path>
          <path
            d="M18.1991209,92.8004907 C17.1315554,91.7331698 15.4004863,91.7331698 14.3326475,92.8004907 L0.800674108,106.332829 C-0.266891369,107.400423 -0.266891369,109.131539 0.800674108,110.199407 C1.86851297,111.267001 3.59930863,111.266728 4.66714749,110.199407 L18.1991209,96.6670684 C19.2669597,95.5992007 19.2669597,93.8680849 18.1991209,92.8004907 Z"
            id="Path"
            fill="#09ADB9"
          ></path>
          <path
            d="M18.5,33 C23.7383,33 28,28.7383 28,23.5 C28,18.2617 23.7383,14 18.5,14 C13.2617,14 9,18.2617 9,23.5 C9,28.7383 13.2617,33 18.5,33 Z M18.5,19.4285714 C20.7449857,19.4285714 22.5714286,21.2550143 22.5714286,23.5 C22.5714286,25.7449857 20.7449857,27.5714286 18.5,27.5714286 C16.2550143,27.5714286 14.4285714,25.7449857 14.4285714,23.5 C14.4285714,21.2550143 16.2550143,19.4285714 18.5,19.4285714 Z"
            id="Shape"
            fill="#000000"
            fillRule="nonzero"
          ></path>
          <path
            d="M105.5,97 C99.7103,97 95,101.7103 95,107.5 C95,113.2897 99.7103,118 105.5,118 C111.2897,118 116,113.2897 116,107.5 C116,101.7103 111.2897,97 105.5,97 Z M105.5,112.75 C102.60515,112.75 100.25,110.39485 100.25,107.5 C100.25,104.60515 102.60515,102.25 105.5,102.25 C108.39485,102.25 110.75,104.60515 110.75,107.5 C110.75,110.39485 108.39485,112.75 105.5,112.75 Z"
            id="Shape"
            fill="#09ADB9"
          ></path>
          <circle
            id="Oval"
            fill="#000000"
            fillRule="nonzero"
            cx="43.5"
            cy="6.5"
            r="2.5"
          ></circle>
          <circle
            id="Oval"
            fill="#000000"
            fillRule="nonzero"
            cx="11.5"
            cy="43.5"
            r="2.5"
          ></circle>
          <circle id="Oval" fill="#09ADB9" cx="22.5" cy="88.5" r="2.5"></circle>
          <circle
            id="Oval"
            fill="#000000"
            fillRule="nonzero"
            cx="115.5"
            cy="88.5"
            r="2.5"
          ></circle>
          <circle
            id="Oval"
            fill="#000000"
            fillRule="nonzero"
            cx="83.5"
            cy="112.5"
            r="2.5"
          ></circle>
          <circle
            id="Oval"
            fill="#09ADB9"
            cx="38.5"
            cy="115.5"
            r="2.5"
          ></circle>
        </g>
      </g>
    </g>
  </svg>
);

export default TimeFlyingSVG;
